angular.module('SpidApp')

.controller('AgencyController',
        ['$scope', 'Restangular', '$localStorage', 'AgencyService', 'UserService', '$rootScope', 'CurrencyService', 'Toaster',
function ($scope,   Restangular,   $localStorage,   AgencyService,   UserService,   $rootScope,   CurrencyService,   Toaster) {

	CurrencyService.all().then(function (currencies) {
		$scope.currencies = currencies;
	})
	
	$scope.saveAgency = function (agency) {
		return AgencyService.save(agency).then(function () {
			return fetchAgencies();
		}).then(function () {
			Toaster.show("L'agence a été sauvegardée")
		}).catch(function (error) {
			console.error('AgencyService::save() - ', error)
		})
	}
	
	$scope.saveAgencies = function () {
		var agencies = $scope.agencies;
		return AgencyService.bulkSave(agencies).then(function () {
			return $scope.fetchAgency().then(function () {
				return fetchAgencies();
			});
		}).then(function () {
			Toaster.show('Les agences ont été sauvegardées')
		}).catch(function (error) {
			console.error('AgencyService::bulkSave() - ', error)
		})
	}
	
	var fetchAgencies = function () {
		return AgencyService.all().then(function(agencies) {
			$scope.agencies = agencies;
		});
	}

	fetchAgencies()
	$scope.restoreAgencies = function () {
		return fetchAgencies().then(function () {
			Toaster.warning('Les agences ont été rechargés')
		})
	}
}])
